import React, { useEffect, useState } from 'react'
import {
  CBadge,
  CButton,
  CRow,
  CSmartTable,
  CAccordion,
  CAccordionItem,
  CAccordionHeader,
  CAccordionBody,
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
  CForm,
  CFormCheck,
} from '@coreui/react-pro'
import { toast } from 'react-toastify'
import ToastComponent from 'src/components/common/TaostComponent.js'
import UserService from 'src/service/UserService'
import AssignMembershipPlan from './AssignMembershipPlan'

const ManageMemebership = () => {
  const [loading, setLoading] = useState(false)
  const [activePage, setActivePage] = useState(1)
  const [columnFilter, setColumnFilter] = useState([])
  const [columnSorter, setColumnSorter] = useState(null)
  const [itemsPerPage, setItemsPerPage] = useState(10)
  const [users, setUsers] = useState([])

  // Modal states
  const [showModal, setShowModal] = useState(false)
  const [selectedUserId, setSelectedUserId] = useState(null)
  const [membershipType, setMembershipType] = useState(1) // default selection

  const columns = [
    { label: 'Member', key: 'full_name' },
    { label: 'Account', key: 'user_role_id' },
    { label: 'Email', key: 'email' },
    { label: 'Status', filter: false, key: 'membership_is_paid' },
    { key: 'action', label: 'Action', filter: false, sorter: false },
  ]

  useEffect(() => {
    fetchData(activePage, columnFilter, columnSorter, itemsPerPage)
  }, [activePage, columnFilter, columnSorter, itemsPerPage])

  const fetchData = (activePage, columnFilter, columnSorter, itemsPerPage) => {
    const offset = itemsPerPage * activePage - itemsPerPage
    let params = new URLSearchParams()
    Object.keys(columnFilter).forEach((key) => {
      params.append(key, columnFilter[key])
    })
    columnSorter &&
      columnSorter.column !== undefined &&
      params.append('sort', `${columnSorter.column}%${columnSorter.state}`)

    UserService.membershipListing(offset, itemsPerPage, activePage, params).then((result) => {
      console.log('Membership Listing Result:', result.data?.data)
      setUsers(result.data)
      setLoading(false)
    })
  }

  const deletMembership = (userId) => {
    setLoading(true)
    UserService.deleteMembershipByAdmin(userId).then((res) => {
      fetchData(activePage, columnFilter, columnSorter, itemsPerPage)
      ToastComponent(res.message, 'success')
      setLoading(false)
      setShowModal(false)
    })
  }

  // Open modal handler
  const handleMarkPaidClick = (userId) => {
    setSelectedUserId(userId)
    setMembershipType(1) // default selection
    setShowModal(true)
  }

  return (
    <>
      <CRow>
        <CAccordion activeItemKey={1}>
          <CAccordionItem itemKey={1}>
            <CAccordionHeader>
              <strong>Manage Members</strong>
            </CAccordionHeader>
            <CAccordionBody>
              <CSmartTable
                columns={columns}
                columnFilter={{ external: true }}
                columnSorter={{ external: true }}
                scopedColumns={{
                  membership_is_paid: (item) => (
                    <td>
                      {item?.membership_is_paid ? (
                        <CBadge color="success">Paid</CBadge>
                      ) : (
                        <CBadge color="danger">Unpaid</CBadge>
                      )}
                    </td>
                  ),
                  user_role_id: (item) => (
                    <td>
                      {item?.user_role_id === 3 ? (
                        <CBadge color="success">Admin</CBadge>
                      ) : (
                        <CBadge color="primary">Member</CBadge>
                      )}
                    </td>
                  ),
                  action: (item) => (
                    <td>
                      {item?.membership_is_paid ? (
                        <CButton
                          color="primary"
                          variant="outline"
                          size="sm"
                          onClick={() => deletMembership(item.id)}
                        >
                          Mark Unpaid
                        </CButton>
                      ) : (
                        <CButton
                          color="primary"
                          variant="outline"
                          size="sm"
                          onClick={() => handleMarkPaidClick(item.id)}
                        >
                          Mark Paid
                        </CButton>
                      )}
                    </td>
                  ),
                }}
                items={users?.data}
                itemsPerPage={itemsPerPage}
                itemsPerPageSelect
                loading={loading}
                pagination={{ external: true }}
                paginationProps={{
                  activePage: activePage,
                  pages: Math.ceil(users?.total / itemsPerPage) || 1,
                }}
                tableProps={{ hover: true, responsive: true }}
                onActivePageChange={(activePage) => setActivePage(activePage)}
                onColumnFilterChange={(filter) => {
                  setActivePage(1)
                  setColumnFilter(filter)
                }}
                onItemsPerPageChange={(itemsPerPage) => {
                  setActivePage(1)
                  setItemsPerPage(itemsPerPage)
                }}
                onSorterChange={(sorter) => setColumnSorter(sorter)}
              />
            </CAccordionBody>
          </CAccordionItem>
        </CAccordion>
      </CRow>

      {showModal && (
        <AssignMembershipPlan
          showModal={showModal}
          setShowModal={setShowModal}
          selectedUserId={selectedUserId}
          membershipType={membershipType}
          setMembershipType={setMembershipType}
          refresh={() => fetchData(activePage, columnFilter, columnSorter, itemsPerPage)}
          toast={ToastComponent}
        />
      )}

      {/* Modal for membership type selection */}
      {/* <CModal visible={showModal} onClose={() => setShowModal(false)}>
        <CModalHeader>
          <CModalTitle>Select Membership Type</CModalTitle>
        </CModalHeader>
        <CForm onSubmit={handleModalSubmit}>
          <CModalBody>
            <div>Select which type of membership to mark as paid:</div>
            <div className="mt-3">
              <CFormCheck
                type="radio"
                name="membershipType"
                id="membershipGame"
                label="Game Membership"
                value="1"
                checked={membershipType === 1}
                onChange={(e) => setMembershipType(e.target.value)}
              />
              <CFormCheck
                type="radio"
                name="membershipType"
                id="membershipAnnual"
                label="Annual Membership"
                value="2"
                checked={membershipType === 2}
                onChange={(e) => setMembershipType(e.target.value)}
              />
            </div>
          </CModalBody>
          <CModalFooter>
            <CButton color="secondary" onClick={() => setShowModal(false)}>
              Cancel
            </CButton>
            <CButton type="submit" color="primary">
              Confirm
            </CButton>
          </CModalFooter>
        </CForm>
      </CModal> */}
    </>
  )
}

export default ManageMemebership
